<template>
    <v-dialog
        :open="name === 'validateAccountDialog'"
        @close="$emit('update:name', '')"
        class="validate-account-dialog"
        title="账号验证"
    >
        <div slot="subtitle">
            {{ subTitle }}
        </div>
        <div
            v-if="validateType === 'all'"
            class="dialog-head"
        >
            <v-tabs
                :value="currentValidateType"
                @input="handleTabChange"
                kind="line"
            >
                <v-tab value="wechat">
                    微信
                </v-tab>
                <v-tab value="mobile">
                    手机
                </v-tab>
            </v-tabs>
        </div>
        <div>
            <div class="dialog-main-content">
                <v-form
                    ref="form"
                    v-if="currentValidateType === 'mobile'"
                    @submit.prevent="formSubmit"
                    kind="desc"
                    class="validate-form"
                >
                    <v-form-item
                        :rules="formRules.mobile"
                        name="mobile"
                        label="手机号"
                        required="请输入手机号"
                        error-placement="bottom-left"
                    >
                        <v-input
                            ref="formInput"
                            v-model="form.mobile"
                            name="mobile"
                        />
                    </v-form-item>
                    <v-form-item
                        :rules="formRules.sms_code"
                        name="sms_code"
                        error-placement="bottom-left"
                        label="验证码"
                        required="请输入验证码"
                        class="v-form-item-smscode"
                    >
                        <v-input
                            v-model="form.sms_code"
                            style="width:160px;"
                        />
                        <v-button
                            :disabled="isCountdown || !form.mobile"
                            :loading="captchaLoading"
                            @click="sendCaptcha"
                            class="captch-btn"
                        >
                            {{ isCountdown ? `${validateFormCountdown}s` : '获取验证码' }}
                        </v-button>
                    </v-form-item>
                    <v-form-item class="btn-item">
                        <v-button
                            :loading="formLoading"
                            type="submit"
                            class="bind-btn"
                            style="width:150px;"
                            kind="primary"
                            size="large"
                        >
                            验证账号
                        </v-button>
                    </v-form-item>
                </v-form>
                <div
                    v-if="currentValidateType === 'wechat'"
                    class="wechat"
                >
                    <div class="qrcode">
                        <qd-login-wx
                            ref="wx"
                            :show-tips="false"
                            :custom-message-handle="true"
                            :redirect-url="WECHAT.VALIDATE_WECHAT"
                            @message="handleMessageHandler"
                            render-id="WxLoginValidate"
                        />
                    </div>
                    <p class="description">
                        请使用账号名为{{ wechatName }}的微信进行扫描验证
                    </p>
                </div>
                <div class="tip">
                    <text-button
                        @click="handleJumpValid"
                        class="text-button"
                    >
                        无法进行账号验证？
                    </text-button>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import { encryptTel } from '@/components/international-tel-input/utils';
import Gateway from '@/utils/Gateway';
import QdLoginWx from '../wechat.js';
import TextButton from '../text-button';
import WECHAT from './const';

const GET_CAPTCHA = '/v1/basic.account.account_web.AccountWeb/SendLoginMSG';
const LOGIN_URL = '/v1/basic.account.account_web.AccountWeb/VerifyMobile'; // 手机登录验证
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
};
const COUNT_DOWN_INIT = 60;
export default {
    filters: {
        encryptTel,
    },
    components: {
        TextButton,
        QdLoginWx,
    },
    props: {
        loginMobile: {
            type: String,
            default: '',
        },
        wechatName: {
            type: String,
            default: '',
        },
        validateType: {
            // 验证的方式：mobile|wechat|all
            type: String,
            default: 'mobile',
        },
        currentValidateType: {
            // 当前的验证类型
            type: String,
            default: 'mobile',
        },
        bindType: {
            type: String,
            default: 'mobile',
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        const vm = this;
        return {
            WECHAT,
            currentValidate: this.currentValidateType,
            formLoading: false,
            captchaLoading: false,
            countdownTimer: null,
            validateFormCountdown: COUNT_DOWN_INIT,
            form: {
                ...DEFAULT_FORM,
                mobile: this.loginMobile || '',
            },
            formRules: {
                mobile: [
                    {
                        validate(val) {
                            return val.length > 0;
                        },
                        message: '手机号不能为空',
                        trigger: 'blur',
                    },
                    {
                        validate(tel) {
                            return /^1(?:\d){10}$/.test(tel);;
                        },
                        message: '手机号格式不正确',
                        trigger: 'blur',
                    },
                ],
                sms_code: [
                    {
                        required: true,
                        message: '验证码不能为空',
                        trigger: 'blur',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: '验证码格式错误',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isCountdown() {
            return this.validateFormCountdown < COUNT_DOWN_INIT;
        },
        subTitle() {
            switch (this.validateType) {
            case 'wechat':
                return '完成账号安全验证后可绑定新的手机号';
            case 'mobile':
                return '完成账号安全验证后可绑定新的微信账号';
            default:
                return '完成以下任一账号安全验证后可绑定新的微信账号';
                // no-default
            }
        },
    },
    methods: {
        // handleClick() {
        //     this.$emit('on-validate-success', {
        //         changeType: this.bindType,
        //         data: {
        //             returnDialogName: 'validateAccountDialog'
        //         }
        //     });
        // },
        handleTabChange(type) {
            console.log(type);
            this.$emit('update:currentValidateType', type);
        },
        validateSuccess() {
            this.$emit('on-validate-success', {
                changeType: this.bindType,
                data: {
                    returnDialogName: 'validateAccountDialog',
                },
            });
        },
        handleMessageHandler(res) {
            const { data } = res.data;
            if (data.code === 0) {
                this.$message.success('微信验证成功');
                this.validateSuccess();
            } else {
                this.$message.error(data.message);
            }
        },
        handleJumpValid() {
            /**
             * 1. 如果只绑定了手机，绑定微信时，需要验证手机，跳过手机验证，直接绑定微信
             * 2. 如果只绑定了微信，绑定手机时，需要验证微信，跳过微信验证，直接绑定手机
             * 3. 如果手机和微信都绑定了，需要验证手机/微信，跳过直接绑定
             */
            this.$emit('on-jump-validate', {
                changeType: this.bindType,
                data: {
                    returnDialogName: 'validateAccountDialog',
                },
            });
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
        },
        validateStartCountdown() {
            /* eslint-disable no-plusplus */
            this.validateFormCountdown--;
            this.countdownTimer = setInterval(() => {
                this.validateFormCountdown--;
                if (this.validateFormCountdown <= -1) {
                    this.clearCountdownTimer();
                    this.validateFormCountdown = COUNT_DOWN_INIT;
                }
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearCountdownTimer);
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            if (!/^1(?:\d){10}$/.test(this.form.mobile)) {
                return;
            }
            this.captchaLoading = true;
            const form = {
                mobile: this.form.mobile,
                type: 1,
            };
            Gateway.post(GET_CAPTCHA, form)
                .then(() => {
                    // data.code = 1003 [1003]验证码发送频繁，请稍后再试
                    this.validateStartCountdown();
                    this.captchaLoading = false;
                })
                .catch((err) => {
                    this.captchaLoading = false;
                    this.$message.error(err || '网络故障，请稍后再试');
                    throw err;
                });
        },
        formSubmit() {
            this.formLoading = true;
            console.log('验证手机号成功', this.form);
            // this.isValiateStep = false;
            const params = {
                phone_number: this.form.mobile,
                sms_code: this.form.sms_code,
            };
            Gateway.post(LOGIN_URL, params)
                .then(() => {
                    this.formLoading = false;
                    this.$message.success('手机验证成功');
                    this.validateSuccess();
                })
                .catch((err) => {
                    this.formLoading = false;
                    this.$message.error(err || '网络故障，请稍后再试');
                });
        },
    },
};
</script>

<style lang="less">
.validate-account-dialog {
    .v-dialog__content {
        width: 450px;
        padding: 40px 0 45px;
    }
    .dialog-main-content {
        padding: 0 40px;
        margin-top: 35px;
        .validate-form {
            .form-label {
                margin-right: 15px;
            }
            .captch-btn {
                min-width: 102px;
                float: right;
                vertical-align: middle;
                top: -6px;
                margin-left: 6px;
            }
            .btn-item {
                margin-top: 60px;
                .v-form-item__input {
                    width: 100%;
                    .bind-btn {
                        float: none;
                    }
                }

                .v-description-item--text-content {
                    display: none;
                }
            }
        }
        .wechat {
            margin-top: -20px;
            .qrcode {
                // width: 200px;
                // height: 200px;
                display: block;
                margin: 0 auto;
                // #wxLoginQrcode {
                //   width: 200px !important;
                //   height: 200px !important;
                // }
            }
            .description {
                margin-top: 5px;
                line-height: 20px;
                font-size: 14px;
                color: #1e2330;
                padding-bottom: 10px;
            }
        }
    }
    .tip {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        .text-button {
            font-size: 12px;
            line-height: 17px;
        }
    }
    .v-form-item-smscode {
        .v-description-item--text-content {
            width: 92px;
        }

        .v-description-item--value {
            display: inline-flex;

        }
        .v-form-item__bterr {
            margin-top: 34px;
        }
    }
}
</style>
